import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/LandingPage.css';
import Header from '../Header';
import Footer from '../Footer';

// Import images
import heroBg from '../../assets/images/landing/hero-bg.jpg';
import valuationExpert from '../../assets/images/landing/valuation-expert.jpg';
import networking from '../../assets/images/landing/networking.jpg';
import valuation from '../../assets/images/landing/valuation.jpg';

function LandingPage() {
  return (
    <div className="landing-page">
      {/* Header/Navigation */}
      <Header />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-heading">UNITING<br />VALUERS<br />NATIONWIDE</h1>
          <p className="hero-tagline">"for a Unified Cause & Strategic Reforms"</p>
        </div>
        <div className="hero-description">
          <p>
            Bangalore Valuers' Association popularly known as "BVA" provides a platform 
            where Valuation professionals in Securities and Financial Category (SFA) can 
            upskill their knowledge through regular workshops and educational programs led 
            by leading industry experts. BVA also provides a community of enthusiastic 
            Registered Valuers who believe in the power of shared knowledge. Our regular 
            online and offline programs offer opportunities to enhance your skills and 
            expand your professional networking, so as to achieve new insights and 
            make a significant impact in Valuation Profession.
          </p>
          <Link to="/membership">
            <button className="btn btn-primary">BECOME A MEMBER</button>
          </Link>
        </div>
      </section>

      {/* Why BVA Section */}
      <section className="why-bva-section" id="about">
        <h2>WHY BVA</h2>
        <p className="section-subtitle">Where Quality Networking Meets Professional Growth</p>
        
        <div className="why-bva-content">
          <div className="why-bva-text">
            <p>
              Joining the Bangalore Valuers' Association means stepping 
              into a world of professional networking and growth through 
              knowledge sharing. The association conducts workshops 
              and seminars meticulously led by industry-leading valuation 
              experts, ensuring you stay at the forefront of industry knowledge 
              and developments. What sets BVA workshops apart is that 
              they are designed to be highly interactive, offering you the 
              unique opportunity to clear any doubts and engage directly with 
              industry experts. This interactive approach provides you with 
              personalized feedback and insights, enhancing your understanding 
              and application of complex valuation concepts. The association's focus 
              on creating a nurturing and supportive environment ensures that you 
              are not only well-informed but also well-connected, fostering 
              relationships that can drive your career forward in meaningful ways.
            </p>
            <Link to="/about-us">
              <button className="btn btn-primary">READ MORE</button>
            </Link>
          </div>
          <div className="why-bva-image" style={{ backgroundImage: `url(${valuationExpert})` }}>
          </div>
        </div>
      </section>}
      <section className="membership-section" id="membership">
        <h2>OUR MEMBERSHIP</h2>
        <p className="section-subtitle">Exceptional Value. Unmatched Benefits</p>
        
        <div className="membership-content">
          <div className="membership-text">
            <p>
              The Bangalore Valuers' Association (BVA) 
              is created primarily for valuers in asset 
              class Securities and Financial Assets. The 
              membership is open (paid basis) and is not 
              restricted to Bangalore-based valuers. 
              BVA conducts workshops usually in physical 
              mode but members may also join in through 
              online mode. The workshops are conducted once 
              a month (Second and fourth Saturdays) on 
              various areas of valuation. Industry 
              professionals (experts) impart, update, share their 
              knowledge and experience with members in 
              these workshops.
            </p>
            <Link to="/membership">
              <button className="btn btn-primary">JOIN BVA</button>
            </Link>
          </div>
          <div className="membership-image" style={{ backgroundImage: `url(${networking})` }}>
          </div>
        </div>
      </section>
       {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2>WHAT OUR MEMBERS SAY</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="author-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div className="author-info">
                <h4>T V S Siva Prasad</h4>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
            <div className="testimonial-content">
              <div className="quote-icon">
                <i className="fas fa-quote-left"></i>
              </div>
              <div className="testimonial-text">
                <p className="testimonial-excerpt">
                  "I feel proud to be a part of BVA where sharing of knowledge in
                  valuation is the motto. The webinars conducted by BVA are of top
                  notch quality and I learned a lot from them..."
                </p>
                <div
                  className="full-testimonial"
                  style={{ display: "none" }}
                >
                  <p>
                    "My journey with Bangalore Valuers' Association (BVA) - A
                    senior office bearer of central committee of ICMAI advised me
                    to study Valuation course. A professional colleague advised me
                    to join the valuation classes, which had just started and
                    immediately joined the 50 hours mandatory coaching. Being
                    qualified as a Valuer had given me immense happiness and a
                    sense of recognition. I joined Bangalore Valuers' Association
                    (BVA) even before passing the valuation examination, on the
                    advice of the founding members of the BVA. I feel proud to be
                    a part of BVA where sharing of knowledge in valuation is the
                    motto of BVA. It's dedicated members and the Management
                    Committee take BVA to greater heights every passing year. The
                    webinars conducted by BVA are of top notch quality. Second
                    and Fourth Saturday mornings are BVA webinar days,
                    invariably. I doubt whether any webinar was not conducted by
                    BVA on the designated days. I learned a lot from the webinars
                    of BVA and my doubts are clarified by my senior members of
                    BVA. I recommended BVA to my qualified valuer friends and many
                    of them joined BVA. I wish BVA all success in its endeavors
                    to make it the Best Source of Knowledge in Valuation subjects."
                  </p>
                </div>
                <button
                  className="read-more-btn"
                  onClick={(e) => {
                    const card = e.target.closest(".testimonial-card");
                    const excerpt = card.querySelector(".testimonial-excerpt");
                    const full = card.querySelector(".full-testimonial");
                    const btn = e.target;

                    if (full.style.display === "none") {
                      excerpt.style.display = "none";
                      full.style.display = "block";
                      btn.textContent = "Read Less";
                    } else {
                      excerpt.style.display = "block";
                      full.style.display = "none";
                      btn.textContent = "Read More";
                    }
                  }}
                >
                  Read More
                </button>
              </div>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="author-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div className="author-info">
                <h4>CS Jeevika Poddar</h4>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
            <div className="testimonial-content">
              <div className="quote-icon">
                <i className="fas fa-quote-left"></i>
              </div>
              <div className="testimonial-text">
                <p className="testimonial-excerpt">
                  "Joining BVA was one of the best decisions I made. Their
                  regular webinars, updates, and knowledge-sharing sessions have
                  been very useful in building both my confidence and
                  understanding..."
                </p>
                <div
                  className="full-testimonial"
                  style={{ display: "none" }}
                >
                  <p>
                    "I got introduced to the field of valuation through an email
                    from ICSI about the Registered Valuer course. Since I've
                    always enjoyed working with numbers, the course immediately
                    caught my interest. With the Companies Act making valuation
                    reports compulsory in many situations, I felt this was a great
                    area to explore further. My Journey With Bangalore Valuers'
                    Association (BVA) - After I cleared the exam, a close friend
                    told me about BVA. Joining BVA was one of the best decisions
                    I made. It is one of the leading bodies in the valuation field
                    and has really helped me grow as a professional. Their regular
                    webinars, updates, and knowledge-sharing sessions have been
                    very useful in building both my confidence and understanding.
                    Being a part of the BVA community has been a blessing. It
                    connects valuers from all over the country and creates a space
                    where everyone is open to helping each other. Whether it's
                    clearing doubts or sharing practical tips, the support from
                    fellow members has always been amazing. I'm truly grateful to
                    be part of this group. It keeps me motivated, helps me stay
                    updated and has given me a strong sense of belonging in the
                    valuation field."
                  </p>
                </div>
                <button
                  className="read-more-btn"
                  onClick={(e) => {
                    const card = e.target.closest(".testimonial-card");
                    const excerpt = card.querySelector(".testimonial-excerpt");
                    const full = card.querySelector(".full-testimonial");
                    const btn = e.target;

                    if (full.style.display === "none") {
                      excerpt.style.display = "none";
                      full.style.display = "block";
                      btn.textContent = "Read Less";
                    } else {
                      excerpt.style.display = "block";
                      full.style.display = "none";
                      btn.textContent = "Read More";
                    }
                  }}
                >
                  Read More
                </button>
              </div>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="author-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div className="author-info">
                <h4>CA Prashant Karanth</h4>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
            <div className="testimonial-content">
              <div className="quote-icon">
                <i className="fas fa-quote-left"></i>
              </div>
              <div className="testimonial-text">
                <p className="testimonial-excerpt">
                  "BVA has been a very positive influence on my professional
                  career with enriching experiences. The group has high-thinking
                  individuals who are seasoned and experienced..."
                </p>
                <div
                  className="full-testimonial"
                  style={{ display: "none" }}
                >
                  <p>
                    "BVA has been a very Positive Influence on My professional
                    career with lot of Enriching experiences by Being passive
                    observer to lot of High quality Discussions in the Group. The
                    Group has lot of High Thinking Individuals who have are
                    seasoned and experienced in Handling lot of High Stake
                    assignments. The Weekend online Seminars have also been of
                    great value with Lot of High Quality Speakers enlightening the
                    Group with Their real life experiences. The best Part about
                    the group is lot of Learned individuals who are willing to
                    share their learnings without any expectations. One can say
                    Learning and Sharing is the Most important attribute of BVA.
                    Credit to the managing Committee and the members who are
                    making this group one of the best places to be."
                  </p>
                </div>
                <button
                  className="read-more-btn"
                  onClick={(e) => {
                    const card = e.target.closest(".testimonial-card");
                    const excerpt = card.querySelector(".testimonial-excerpt");
                    const full = card.querySelector(".full-testimonial");
                    const btn = e.target;

                    if (full.style.display === "none") {
                      excerpt.style.display = "none";
                      full.style.display = "block";
                      btn.textContent = "Read Less";
                    } else {
                      excerpt.style.display = "block";
                      full.style.display = "none";
                      btn.textContent = "Read More";
                    }
                  }}
                >
                  Read More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Footer */}
      <Footer />
    </div>
  );
}

export default LandingPage;